import {
    createActionComparatorFactory,
    createActionTypeFactory,
    createNamespaceActionCreatorFactory, createNamespaceReducerFactory,
    createNamespaceSelectorFactory,
    IActionComparatorFactory, IActionReducerFactory,
    IActionTypeFactory, INamespaceActionCreatorFactory, ISelectorFactory,
} from '@omaze/redux';

import { IEmailCaptureState } from './email-capture.state';

export const EMAIL_CAPTURE_NAMESPACE: string = 'email-capture';

export const createEmailCaptureActionType: IActionTypeFactory = createActionTypeFactory(EMAIL_CAPTURE_NAMESPACE);

export const createEmailCaptureActionCreatorFactory: INamespaceActionCreatorFactory = createNamespaceActionCreatorFactory(EMAIL_CAPTURE_NAMESPACE);

export const createEmailCaptureReducerFactory: IActionReducerFactory<IEmailCaptureState> = createNamespaceReducerFactory<IEmailCaptureState>(EMAIL_CAPTURE_NAMESPACE);

export const createEmailCaptureSelector: ISelectorFactory<IEmailCaptureState> = createNamespaceSelectorFactory<IEmailCaptureState>(EMAIL_CAPTURE_NAMESPACE);

export const createEmailCaptureActionComparator: IActionComparatorFactory =
    createActionComparatorFactory(EMAIL_CAPTURE_NAMESPACE);
